import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { Card as MuiCard } from '@mui/material'
import CommonCardHeader from './CardHeader'
import CommonCardContent from './CardContent'
import CommonCardFooter from './CardFooter'

const PREFIX = 'Card'

const classes = {
  defaultOverlay: `${PREFIX}-defaultOverlay`,
}

const StyledMuiCard = styled(MuiCard)(({ theme }) => ({
  [`& .${classes.defaultOverlay}`]: {
    padding: 12,
  },
}))

const Card = props => {
  const cardOverlayStyles = props.cardOverlayStyles
    ? props.cardOverlayStyles
    : classes.defaultOverlay

  return (
    <StyledMuiCard
      className={cardOverlayStyles}
      onClick={props.onClick}
      key={props.cardId}
    >
      <CommonCardHeader {...props} />
      <CommonCardContent {...props} />
      <CommonCardFooter {...props} />
    </StyledMuiCard>
  )
}

Card.propTypes = {
  cardId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  content: PropTypes.object,
  image: PropTypes.string,
  onClick: PropTypes.func,
}

Card.muiName = MuiCard.muiName

export default Card
